import React, { useEffect, useState ,memo} from 'react';
import { PDFViewer, PDFDownloadLink, Document, Page, Text, View, Image, Font } from '@react-pdf/renderer';
import { Button } from "@nextui-org/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import logo from '../../Images/logo.png'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import axios from 'axios';
import BackEndUrl from '../../backURL';

const backend = BackEndUrl.domain;
function EnhacementLetter(data) {
  const { data: req_data } = data
  const [oldTableInfo, setOldTableInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  async function GetTableDetails(id, table_name) {

    try {
      setIsLoading(true)
      
      const response = await axios.post(backend + "/get-old-table-details", {

        table_name: table_name,
        id: id


      }, {
        headers: {
          Authorization: sessionStorage.getItem('token'),
        }
      })
      
      setOldTableInfo(response.data[0])
      setIsLoading(false)
    } catch (err) {
      console.log(err)

    }
  }
  

  const MyDocument = ({ data }) => {     
      
  
    useEffect (()=>{
      if(!oldTableInfo&&data&&data?.table_id){
              GetTableDetails(data?.table_id, data?.table_name);
      }
      },[])
      

    return(
      <Document>

      <Page>
        <View>
          <Image src={logo} style={{ width: "15%", padding: "1vh" }} />
        </View>

        {data && data.type_of_req == "add_data" ?
          <>


          </>

          :
          null}
         

        {data && data.type_of_req == "alteration_data" && data.req_type == "Contact Number " ?
          <>

            <View style={{ padding: "20" }}>
              <Text style={{ fontSize: "12" }}> {data.name}</Text>
              <Text style={{ fontSize: "12" }}> {data.address1}</Text>
              <Text style={{ fontSize: "12" }}> {data.address2}</Text>
              <Text style={{ fontSize: "12" }}> {data.address3}</Text>
              <Text style={{ fontSize: "12" }}> {data.address4}</Text>
              <Text style={{ fontSize: "12", marginTop: "30", marginBottom: "30" }}>Dear Sir /Madam</Text>

            </View>
            <View style={{ marginTop: "20", marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontStyle: "bold", fontSize: "12", textDecoration: "underline", textAlign: "center" }}>AIC: .................... Confirmation of Telephone Number Change</Text>


            </View>
            <View style={{ marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontSize: "12" }}>I hope this message finds you well. Thank you for reaching out to us regarding the update of
                your contact information. We have successfully processed your request to change your
                telephone number in our records.</Text>


            </View>
            <View style={{ marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontSize: "12", color: "grey" }}>Thank you for choosing Sanasa Life Insurance Company PLC. We appreciate your continued
                trust in our services.</Text>


            </View>
            <View >
              <Text style={{ fontSize: "12", marginTop: "30", marginLeft: "30", marginRight: "30" }}>Best regards,</Text>


            </View>



          </>

          :
          null}
        {data && data.type_of_req == "alteration_data" && data.req_type == "Policy Address " ?
          <>

            <View style={{ padding: "20" }}>
              <Text style={{ fontSize: "12" }}> {data.name}</Text>
              <Text style={{ fontSize: "12" }}> {data.address1}</Text>
              <Text style={{ fontSize: "12" }}> {data.address2}</Text>
              <Text style={{ fontSize: "12" }}> {data.address3}</Text>
              <Text style={{ fontSize: "12" }}> {data.address4}</Text>
              <Text style={{ fontSize: "12", marginTop: "30", marginBottom: "30" }}>Dear Sir /Madam</Text>

            </View>
            <View style={{ marginTop: "20", marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontStyle: "bold", fontSize: "12", textDecoration: "underline", textAlign: "center" }}>AIC:.................... Confirmation of Address Change</Text>


            </View>
            <View style={{ marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontSize: "12" }}>I trust this message finds you well. Thank you for bringing to our attention the update to your contact
                information, specifically the change of your address. We have successfully processed your request.</Text>


            </View>
            <View style={{ marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontSize: "12" }}>New Address: {data.new_data}</Text>


            </View>
            <View style={{ marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontSize: "12" }}>This change is effective immediately, and all future correspondence and shipments will be directed to
                your updated address.</Text>


            </View>
            <View style={{ marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontSize: "12", color: "grey" }}>Thank you for choosing Sanasa Life Insurance Company PLC. We appreciate your continued trust in our
                services.</Text>


            </View>
            <View >
              <Text style={{ fontSize: "12", marginTop: "30", marginLeft: "30", marginRight: "30" }}>Best regards,</Text>


            </View>



          </>

          :
          null}
        {data && oldTableInfo&&data.type_of_req == "alteration_data" && data.table_name == "nominee" || data.table_name == "beneficiaries" ?

          <>

            <View style={{ padding: "20" }}>
              <Text style={{ fontSize: "12" }}> {data.name}</Text>
              <Text style={{ fontSize: "12" }}> {data.address1}</Text>
              <Text style={{ fontSize: "12" }}> {data.address2}</Text>
              <Text style={{ fontSize: "12" }}> {data.address3}</Text>
              <Text style={{ fontSize: "12" }}> {data.address4}</Text>
              <Text style={{ fontSize: "12", marginTop: "30", marginBottom: "30" }}>Dear Sir /Madam</Text>

            </View>
            <View style={{ marginTop: "20", marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontStyle: "bold", fontSize: "12", textDecoration: "underline", textAlign: "center" }}>AIC : ..................... Confirmation of Nominee/Beneficiary Information Update</Text>


            </View>
            <View style={{ marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontSize: "12" }}>I trust this letter finds you well. Thank you for notifying us of the change in nominee/beneficiary
                information associated with your {oldTableInfo?.policy_number} with Sanasa Life Insurance Company PLC. We have
                duly processed your request, and the updated information has been recorded in our system.</Text>


            </View>
            <View style={{ marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontSize: "12" }}>Old Nominee/Beneficiary Information:</Text>
              
              {data.req_type == "percentage" &&
                <Text style={{ fontSize: "12" }}>-  Old Name: {oldTableInfo.name}</Text>
              }
              <Text style={{ fontSize: "12" }}>- {data.req_type}: {data.old_data}</Text>



            </View>
            <View style={{ marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontSize: "12" }}>New Nominee/Beneficiary Information:</Text>

              {data.req_data == "percentage" &&
                <Text style={{ fontSize: "12" }}>-Old Name: {oldTableInfo.name}</Text>
              }
              <Text style={{ fontSize: "12" }}>- {data.req_type}: {data.new_data}</Text>



            </View>

            <View style={{ marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontSize: "12" }}>Your records have been updated accordingly, and all future communications and transactions will reflect
                the new nominee/beneficiary details.</Text>


            </View>
            <View style={{ marginBottom: "20", marginLeft: "30", marginRight: "30" }}>
              <Text style={{ fontSize: "12", color: "grey" }}>We appreciate your prompt attention to this matter and value your continued trust in Sanasa Life
                Insurance Company PLC. Thank you for choosing us as your service provider.</Text>


            </View>
            <View >
              <Text style={{ fontSize: "12", marginTop: "30", marginLeft: "30", marginRight: "30" }}>Best regards,</Text>


            </View>



          </>

          :
          null}
      </Page>
    </Document>
    );
   
  };

  return (
    <div>


      {/* PDFDownloadLink for downloading the PDF */}
      <PDFDownloadLink document={<MyDocument data={req_data} />} fileName={`request_doc_${req_data && req_data.req_id}.pdf`}>
        {({ blob, url, loading, error }) =>
          loading ?
            <Button isLoading style={{ color: "white", backgroundColor: "#F5190E" }} >

            </Button>

            :
            !isLoading ?
              <Button isIconOnly style={{ color: "white", backgroundColor: "#F5190E" }} >
                <FontAwesomeIcon icon={faFilePdf} style={{ height: "2.5vh" }} />
              </Button> :
              <Button isLoading style={{ color: "white", backgroundColor: "#F5190E" }} >

              </Button>
        }
      </PDFDownloadLink>
    </div>
  )
    ;
}

export default EnhacementLetter;
